import * as React from 'react';
import cx from 'classnames';
import { template } from 'utils/stringUtils';
import Button from 'components/Button';
import successIcon from 'images/toast_success.svg';
import errorIcon from 'images/toast_error.svg';
import infoIcon from 'images/toast_info.svg';
export var TOAST_LEVELS;
(function (TOAST_LEVELS) {
    TOAST_LEVELS["INFO"] = "INFO";
    TOAST_LEVELS["SUCCESS"] = "SUCCESS";
    TOAST_LEVELS["ERROR"] = "ERROR";
    TOAST_LEVELS["NONE"] = "NONE";
})(TOAST_LEVELS || (TOAST_LEVELS = {}));
import styles from './Toast.css';
const imgSrc = {
    INFO: infoIcon,
    SUCCESS: successIcon,
    ERROR: errorIcon,
    NONE: ''
};
const defaultToast = {
    message: '',
    level: TOAST_LEVELS.INFO,
    image: null,
    button: null,
    visible: false,
    theme: ''
};
export default class Toast extends React.Component {
    constructor(props) {
        super(props);
        this.show = (message, params) => this.handleShow(message, params);
        this.hide = () => this.handleHide();
        this.handleClick = () => {
            if (this.state.toast && this.state.toast.button && typeof this.state.toast.button.onClick === 'function') {
                this.state.toast.button.onClick();
                this.handleHide();
            }
        };
        this.handleShow = (message, params) => {
            if (this.state.toast.visible) {
                if (this.timeout)
                    clearTimeout(this.timeout);
                this.handleHide(() => this.handleShow(message, params));
                return;
            }
            this.setState({
                toast: Object.assign({}, defaultToast, message, {
                    message: template(message.message, params)
                }, {
                    visible: true
                })
            });
            if (!message.dismissible && message.ttl !== -1) {
                this.timeout = setTimeout(() => this.handleHide(), message.ttl || 5000);
            }
        };
        this.showSuccess = (message) => {
            this.show(Object.assign({}, message, { level: 'SUCCESS' }));
        };
        this.showError = (message) => {
            this.show(Object.assign({}, message, { level: 'ERROR' }));
        };
        this.handleHide = (callback) => {
            if (this.toast) {
                this.transitionendCallback = () => {
                    this.toast && this.toast.removeEventListener('transitionend', this.transitionendCallback);
                    this.transitionendCallback = null;
                    this.setState(state => ({
                        toast: Object.assign({}, state.toast, { visible: false })
                    }), () => {
                        window.requestAnimationFrame(() => typeof callback === 'function' && callback());
                    });
                };
                this.toast.addEventListener('transitionend', this.transitionendCallback);
                this.toast.classList.remove(styles['active']);
            }
        };
        this.toastRef = c => (this.toast = c);
        this.state = {
            toast: Object.assign({}, defaultToast)
        };
    }
    shouldComponentUpdate(_, nextState) {
        return this.state.toast.visible !== nextState.toast.visible;
    }
    componentDidUpdate() {
        if (this.state.toast.visible) {
            window.requestAnimationFrame(() => this.toast && this.toast.classList.add(styles['active']));
        }
    }
    componentWillUnmount() {
        if (this.transitionendCallback) {
            this.toast && this.toast.removeEventListener('transitionend', this.transitionendCallback);
            this.transitionendCallback = null;
        }
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    }
    render() {
        const { toast: { message, level, image, button, visible, theme, buttonText, dismissible } } = this.state;
        const classes = cx(styles['toast-card'], {
            [styles['light']]: theme === 'LIGHT'
        });
        if (!visible)
            return null;
        return (<div className={styles['toast-container']}>
				<div ref={this.toastRef} className={classes}>
					<div className={styles['toast-wrapper']}>
						{level !== TOAST_LEVELS.NONE && (<div className={styles['icon-container']}>
								<img src={imgSrc[level]} className={styles['icon']}/>
							</div>)}
						{image ? (<div className={styles['image-container']}>
								<img src={image} className={styles['toast-image']} alt="toast image"/>
							</div>) : null}
						<div className={styles['message-container']}>{message}</div>
						{button ? (<div className={styles['btn-container']}>
								<Button className={styles['toast-btn']} href={button.href} external={button.external} onClick={this.handleClick}>
									{buttonText || button.text}
								</Button>
							</div>) : null}
						{dismissible ? (<div className={styles['dismiss-container']}>
								<Button className={styles['dismiss-btn']} onClick={this.handleHide}>
									✕
								</Button>
							</div>) : null}
					</div>
				</div>
			</div>);
    }
}
export { default as withToast } from './withToast';
export { default as toastContext } from './context-shape';
